module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-styled-components@6.15.0_babel-plugin-styled-components@2.3.0_@babel+core_c317fe57ee851aa2a6ce70728fb438dc/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":false,"disableVendorPrefixes":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.15.0_@babel+plugin-syntax-flow@7.29.7_@babel+core@7.29.7_supports-color@10.2.2_195810aa4801f22490f17d9722ec6abe/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
